import React from "react";
import styles from "../../Handbook.module.css";

interface ConfirmDialogProps {
    open: boolean;
    title?: string;
    description?: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmDialog = ({
                                  open,
                                  title = "Удалить запись?",
                                  description = "Это действие нельзя отменить.",
                                  confirmText = "Удалить",
                                  cancelText = "Отмена",
                                  onConfirm,
                                  onCancel,
                              }: ConfirmDialogProps) => {
    if (!open) return null;

    return (
        <div className={styles.modalOverlay}>
            <button
                type="button"
                className={styles.modalBackdropBtn}
                onClick={onCancel}
                aria-label="Закрыть"
            />

            <div className={styles.modalCard}>
                <div className={styles.modalTitle}>{title}</div>

                {description && (
                    <div className={styles.modalDesc}>{description}</div>
                )}

                <div className={styles.modalActions}>
                    <button
                        type="button"
                        className={styles.modalBtn}
                        onClick={onCancel}
                    >
                        {cancelText}
                    </button>

                    <button
                        type="button"
                        className={`${styles.modalBtn} ${styles.modalBtnDanger}`}
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};
